import { Form } from '@/components/formik-rsuite';
import PageLoader from '@/components/shared/PageLoader';
import { LEVEL_TYPE } from '@/constants';
import useCasesBasic from '@/hooks/preload/useCasesBasic';
import { fetchAddEditSuggest } from '@/services/site/suggest';
import { getParamsWithNilToString } from '@/services/utils';
import { push } from '@/utils/history';
import { useRequest } from 'ahooks';
import { FormikProvider, useFormik } from 'formik';
import React, { useState } from 'react';
import { Alert } from 'rsuite';
import { SiteContext } from '..';
import { defaultSuggestInfo, suggestSchema } from './constants';
import Result from './Result';
import CasesInfo from './CasesInfo';
import useLoading from '@/hooks/useLoading';
import useGePcsList from '@/hooks/preload/useGePcsList';
import useSiteBrandList from '@/hooks/preload/useSiteBrandList';
import _ from 'lodash';

const Suggest = () => {
  const { member } = React.useContext(SiteContext);
  const { data: gePcsList, loading: gePcsListLoading } = useGePcsList();
  const { data: brandList, loading: brandListLoading } = useSiteBrandList();
  const { data: casesBasicData, loading: casesBasicLoading } = useCasesBasic();

  const { run: addEditSuggest, loading: addEditSuggestLoading } = useRequest(fetchAddEditSuggest, {
    manual: true,
  });

  const [defaultInfo, setDefaultInfo] = useState(defaultSuggestInfo);

  const loading =
    useLoading(gePcsListLoading || brandListLoading || casesBasicLoading) || addEditSuggestLoading;

  const formik = useFormik({
    initialValues: defaultInfo,
    validationSchema: suggestSchema,
    enableReinitialize: true, // initialValues默认值受控
    onSubmit(values, actions) {
      // 校验投诉问题分类是否各个分类至少选一项
      if (values.cases_category?.length) {
        const categoryGroupArr = casesBasicData.category?.reduce((pre, cur) => {
          return pre.includes(cur?.role) ? pre : pre?.concat(cur?.role);
        }, []);
        const selectedGroupArr = values.cases_category?.reduce((pre, cur) => {
          const role = casesBasicData.category?.find((cate) => cate?.value === cur)?.role;
          return !_.isNil(role) && !pre.includes(role) ? pre?.concat(role) : pre;
        }, []);
        if (selectedGroupArr.length < categoryGroupArr.length) {
          return formik.setFieldError('cases_category', '各分类至少选一项');
        }
      }

      const data = Object.assign({}, getParamsWithNilToString(values), {
        cases_category: JSON.stringify(
          values.cases_category?.map((item) => {
            return {
              cases_category_id: item,
            };
          }) ?? []
        ),
        cases_dispose: JSON.stringify(
          values.cases_dispose?.map((item) => {
            return {
              cases_dispose_id: item,
            };
          }) ?? []
        ),
        [member?.level === LEVEL_TYPE.NOT ? 'not_member_id' : 'member_id']: member?.id,
      });
      addEditSuggest(data)
        .then((res) => {
          if (res?.id) {
            const { id } = res;
            Alert.success(res?.msg ?? '保存成功');
            push(`/site-service/record/info/suggest/${id}`);
          }
        })
        .catch((e) => {
          actions.setErrors(e.formError);
        });
    },
  });

  return (
    <FormikProvider value={formik}>
      {loading && <PageLoader />}
      <Form guard>
        <CasesInfo casesBasic={casesBasicData} brandList={brandList} />
        <Result
          formik={formik}
          casesBasic={casesBasicData}
          gePcsList={gePcsList}
          setDefaultInfo={setDefaultInfo}
        />
      </Form>
    </FormikProvider>
  );
};

export default Suggest;
